var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-config-container" }, [
    _c(
      "div",
      { staticClass: "list-container" },
      [
        _c(
          "el-form",
          {
            staticClass: "compact-search-form",
            attrs: { inline: true, model: _vm.searchForm },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-input", {
                  staticStyle: { width: "220px" },
                  attrs: { placeholder: "活动名称", clearable: "" },
                  model: {
                    value: _vm.searchForm.keywords,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "keywords", $$v)
                    },
                    expression: "searchForm.keywords",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "" } },
              [
                _c("el-date-picker", {
                  attrs: {
                    type: "datetimerange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                  },
                  on: { change: _vm.changeTime },
                  model: {
                    value: _vm.times,
                    callback: function ($$v) {
                      _vm.times = $$v
                    },
                    expression: "times",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "form-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.fetchList } },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.addAct } },
                  [_vm._v("添加活动")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.tableData,
              stripe: "",
              border: "",
              "element-loading-text": "数据加载中...",
              "element-loading-spinner": "el-icon-loading",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                label: "序号",
                width: "60",
                align: "center",
                index: _vm.indexMethod,
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                prop: "activityName",
                label: "活动名称",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "膨胀券名称",
                prop: "couponStartName",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "膨胀后的券",
                prop: "couponEndName",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "分享注册数",
                prop: "registerSuccessCount",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "待膨胀", prop: "todoCount", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "膨胀中",
                prop: "expandingCount",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "膨胀成功",
                prop: "successCount",
                align: "center",
              },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "膨胀失败", prop: "failCount", align: "center" },
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "活动时间",
                prop: "",
                align: "center",
                width: "300",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [_vm._v(_vm._s(scope.row.actTime))]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "活动状态", prop: "status", align: "center" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.status == 0
                        ? _c("el-tag", { attrs: { type: "info" } }, [
                            _vm._v("未启用"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      scope.row.status == 1
                        ? _c("el-tag", { attrs: { type: "success" } }, [
                            _vm._v("已启用"),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "操作",
                align: "center",
                fixed: "right",
                width: "340",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleEdit(scope.row)
                            },
                          },
                        },
                        [_vm._v("编辑")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.detailUser(scope.row)
                            },
                          },
                        },
                        [_vm._v("膨胀明细")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.handleCopy(scope.row)
                            },
                          },
                        },
                        [_vm._v("复制")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getUserList(scope.row.id)
                            },
                          },
                        },
                        [_vm._v("领券用户")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "current-page": _vm.searchForm.page,
                "page-sizes": [10, 20, 30, 50],
                "page-size": _vm.searchForm.limit,
                total: _vm.searchForm.total,
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "领券用户",
              "close-on-click-modal": true,
              visible: _vm.dialogVisible,
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                staticClass: "compact-search-form",
                attrs: { inline: true, model: _vm.searchForm2 },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "220px" },
                      attrs: { placeholder: "用户手机号", clearable: "" },
                      model: {
                        value: _vm.searchForm2.mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm2, "mobile", $$v)
                        },
                        expression: "searchForm2.mobile",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-input", {
                      staticStyle: { width: "220px", "margin-left": "10px" },
                      attrs: { placeholder: "会员卡号", clearable: "" },
                      model: {
                        value: _vm.searchForm2.cardNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm2, "cardNo", $$v)
                        },
                        expression: "searchForm2.cardNo",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "180px", "margin-left": "10px" },
                        attrs: { placeholder: "状态", clearable: "" },
                        model: {
                          value: _vm.searchForm2.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm2, "status", $$v)
                          },
                          expression: "searchForm2.status",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "新用户领券", value: 1 },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "老用户领券", value: 2 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "form-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.getUserList()
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              { attrs: { data: _vm.userList, border: "" } },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "id",
                    label: "ID",
                    width: "60",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "userName",
                    label: "参与用户",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "mobile", label: "手机号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "cardNo", label: "会员卡号", align: "center" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "couponName",
                    label: "优惠券名称",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "couponId",
                    label: "优惠券ID",
                    align: "center",
                  },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "status", label: "状态", align: "center" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.userType == 1
                            ? _c("el-tag", { attrs: { type: "info" } }, [
                                _vm._v("新用户领券"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.userType == 2
                            ? _c("el-tag", { attrs: { type: "success" } }, [
                                _vm._v("老用户领券"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "createDate",
                    label: "领券时间",
                    align: "center",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { float: "right", "margin-top": "20px" } },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    "current-page": _vm.searchForm2.page,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.searchForm2.limit,
                    total: _vm.searchForm2.total,
                  },
                  on: {
                    "current-change": _vm.handlePageChange2,
                    "size-change": _vm.handleSizeChange2,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }